// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mp-cover-container-left {
    position: relative;
    width: 20%;
    margin-left: 20px;
    height: 150px; /* Adjust height as needed */
    overflow: hidden;
    border-radius: 10px;
    background: none;
    justify-items: center;
    align-items: center;
}

.mp-cover-container-right {
    position: relative;
    width: 25%;
    height: 70px; /* Adjust height as needed */
    overflow: hidden;
    border-radius: 10px;
    background: none;
    margin-top: 100px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    align-content: center;
    display: flex;
    flex-direction: row;
}

.mp-profile-photo {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border-width: 3px;
    align-items: center;    
}

.mp-cover-container-User {
    position: relative;
    width: 30%;
    height: 60px; /* Adjust height as needed */
    margin-top: 100px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    align-content: center;
}

.mp-user-text-props {
    font-size: 18px;
    font-weight: lighter;
}

.mp-cover-container-button {
    width: 100px;
    height: 50px;
    border-radius: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/CoverImageUploader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,aAAa,EAAE,4BAA4B;IAC3C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,4BAA4B;IAC1C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,4BAA4B;IAC1C,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".mp-cover-container-left {\n    position: relative;\n    width: 20%;\n    margin-left: 20px;\n    height: 150px; /* Adjust height as needed */\n    overflow: hidden;\n    border-radius: 10px;\n    background: none;\n    justify-items: center;\n    align-items: center;\n}\n\n.mp-cover-container-right {\n    position: relative;\n    width: 25%;\n    height: 70px; /* Adjust height as needed */\n    overflow: hidden;\n    border-radius: 10px;\n    background: none;\n    margin-top: 100px;\n    justify-content: center;\n    justify-items: center;\n    align-items: center;\n    align-content: center;\n    display: flex;\n    flex-direction: row;\n}\n\n.mp-profile-photo {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    border-width: 3px;\n    align-items: center;    \n}\n\n.mp-cover-container-User {\n    position: relative;\n    width: 30%;\n    height: 60px; /* Adjust height as needed */\n    margin-top: 100px;\n    justify-content: center;\n    justify-items: center;\n    align-items: center;\n    align-content: center;\n}\n\n.mp-user-text-props {\n    font-size: 18px;\n    font-weight: lighter;\n}\n\n.mp-cover-container-button {\n    width: 100px;\n    height: 50px;\n    border-radius: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
